import { TextArea, type TextAreaProps } from '@workramp/ui';
import { useEffect, useState } from 'react';
import { useDebouncedCallback } from '~/hooks';

export const TextAreaSetting = ({ value, onChange, ...props }: TextAreaProps) => {
  const [controlledValue, setControlledValue] = useState(value);
  const debouncedChange = useDebouncedCallback(() => onChange(controlledValue));

  useEffect(() => {
    setControlledValue(value);
  }, [value]);

  const handleOnChange = (v: string) => {
    setControlledValue(v);
    debouncedChange();
  };

  return <TextArea value={controlledValue} onChange={handleOnChange} {...props} />;
};
